/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetIndustryFacilities200Ok
 */
export interface GetIndustryFacilities200Ok {
    /**
     * ID of the facility
     * @type {number}
     * @memberof GetIndustryFacilities200Ok
     */
    facilityId: number;
    /**
     * Owner of the facility
     * @type {number}
     * @memberof GetIndustryFacilities200Ok
     */
    ownerId: number;
    /**
     * Region ID where the facility is
     * @type {number}
     * @memberof GetIndustryFacilities200Ok
     */
    regionId: number;
    /**
     * Solar system ID where the facility is
     * @type {number}
     * @memberof GetIndustryFacilities200Ok
     */
    solarSystemId: number;
    /**
     * Tax imposed by the facility
     * @type {number}
     * @memberof GetIndustryFacilities200Ok
     */
    tax?: number;
    /**
     * Type ID of the facility
     * @type {number}
     * @memberof GetIndustryFacilities200Ok
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetIndustryFacilities200Ok interface.
 */
export function instanceOfGetIndustryFacilities200Ok(value: object): value is GetIndustryFacilities200Ok {
    if (!('facilityId' in value) || value['facilityId'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('solarSystemId' in value) || value['solarSystemId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetIndustryFacilities200OkFromJSON(json: any): GetIndustryFacilities200Ok {
    return GetIndustryFacilities200OkFromJSONTyped(json, false);
}

export function GetIndustryFacilities200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIndustryFacilities200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'facilityId': json['facility_id'],
        'ownerId': json['owner_id'],
        'regionId': json['region_id'],
        'solarSystemId': json['solar_system_id'],
        'tax': json['tax'] == null ? undefined : json['tax'],
        'typeId': json['type_id'],
    };
}

export function GetIndustryFacilities200OkToJSON(json: any): GetIndustryFacilities200Ok {
    return GetIndustryFacilities200OkToJSONTyped(json, false);
}

export function GetIndustryFacilities200OkToJSONTyped(value?: GetIndustryFacilities200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facilityId'],
        'owner_id': value['ownerId'],
        'region_id': value['regionId'],
        'solar_system_id': value['solarSystemId'],
        'tax': value['tax'],
        'type_id': value['typeId'],
    };
}

